import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Drawer from "../components/baseMenu";
import NavBar from "../components/navBar";
import { push } from "connected-react-router";
import DocumentTitle from "react-document-title-sz";
import Exception from "../components/Exception";
import { Link } from "react-router-dom";
import layout from "./layout.less";

const Exp = () => (
  <Exception
    type="404"
    desc={"You seem lost!"}
    linkElement={Link}
    redirect={"/publicInstrument"}
    backText={"Go To Homepage?"}
  />
);

function BasicLayout({ component, item }) {
  const dispatch = useDispatch();
  const { token, currentUser } = useSelector((state) => ({
    token: state.global.token,
    currentUser: state.global.currentUser,
  }));

  useEffect(() => {
    if (!token || !currentUser) {
      dispatch(push("/login"));
    }
  }, [currentUser, dispatch, token]);

  return (
    <div className={layout.wraper}>
      <NavBar item={item} currentUser={currentUser} />
      <Drawer />
      <div className={layout.container}>
        <DocumentTitle title={"Exirio | " + item.title || item.name}>
          {!!component ? (
            <Suspense fallback={<div>Loading...</div>}>{component}</Suspense>
          ) : (
            <Exp />
          )}
        </DocumentTitle>
      </div>
    </div>
  );
}

export default React.memo(BasicLayout);
